import { NODE_TYPE_LINK, NODE_TYPE_SUBSTANCE } from '@Pages/RetroSynthesis/ProjectRoute/ProjectRouteTreeView/constants';
import { trimUptoTwoDecimals } from '../../utils';

export const buildTreeFromList = (items = [], group, id, parentStepNumber) =>
  items
    .filter(item => group ? item.group === id : item.parentId === id)
    .map(item => {
      const prependLink = !item.leafNode;
      const _data = { ...item, parentStepNumber };
      _data.confidence = trimUptoTwoDecimals(_data.confidence);
      return {
        _type: NODE_TYPE_SUBSTANCE,
        _data,
        children: item.groups ? item.groups.map((group) => ({
          _type: NODE_TYPE_LINK,
          _data: {
            ..._data,
            group: group.id,
            step: group.id,
            yield: group.yield,
            custom: group.custom,
            type: group.type,
            confidence: trimUptoTwoDecimals(group.confidence),
            reaction: {
              ..._data.reaction,
              reactionId: group.reactionId,
              databaseId: group.databaseId,
            },
            multiStep: group.multiStep,
            multiStepEnrolled: group.multiStepEnrolled,
          },
          children: buildTreeFromList(items, true, group.id, item.step),
        })) : prependLink ?
          [
            {
              _type: NODE_TYPE_LINK,
              _data,
              children: buildTreeFromList(items, false, item.id, item.step),
            },
          ] :
          buildTreeFromList(items, false, item.id, item.step)
      };
    });
